export default {
  title: "Wrong Identifier",
  content:
    "This <b class='text-info'>Identifier</b> belongs to a different <b class='text-info'>Entity</b>.",
}
